import { getAudio } from "@/audio";

const noiseBuffer = (ctx, secs) => {
  const b = ctx.createBuffer(1, ctx.sampleRate * secs, ctx.sampleRate);
  const d = b.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
  return b;
};

const env = (ctx, g, peak, dur) => {
  const n = ctx.currentTime;
  g.gain.setValueAtTime(0.0001, n);
  g.gain.exponentialRampToValueAtTime(peak, n + 0.02);
  g.gain.setValueAtTime(peak, n + dur * 0.7);
  g.gain.exponentialRampToValueAtTime(0.0001, n + dur);
};

const osc = (ctx, out, type, freq, dur) => {
  const o = ctx.createOscillator();
  o.type = type;
  o.frequency.value = freq;
  o.connect(out);
  o.start();
  o.stop(ctx.currentTime + dur);
  return o;
};

const SOUNDS = {
  horn(ctx, out) {
    [233, 294, 349].forEach((f) => osc(ctx, out, "sawtooth", f, 1.2));
    return 1.2;
  },
  siren(ctx, out) {
    const o = osc(ctx, out, "square", 600, 1.4);
    const n = ctx.currentTime;
    o.frequency.linearRampToValueAtTime(1400, n + 0.7);
    o.frequency.linearRampToValueAtTime(600, n + 1.4);
    return 1.4;
  },
  crash(ctx, out) {
    const s = ctx.createBufferSource();
    s.buffer = noiseBuffer(ctx, 1.5);
    const hp = ctx.createBiquadFilter();
    hp.type = "highpass";
    hp.frequency.value = 700;
    s.connect(hp).connect(out);
    s.start();
    return 1.5;
  },
  boom(ctx, out) {
    const o = osc(ctx, out, "sine", 140, 1.1);
    o.frequency.exponentialRampToValueAtTime(35, ctx.currentTime + 1);
    const s = ctx.createBufferSource();
    s.buffer = noiseBuffer(ctx, 0.3);
    s.connect(out);
    s.start();
    return 1.1;
  },
  static(ctx, out) {
    const s = ctx.createBufferSource();
    s.buffer = noiseBuffer(ctx, 1.2);
    const bp = ctx.createBiquadFilter();
    bp.type = "bandpass";
    bp.frequency.value = 300 + Math.random() * 3000;
    bp.Q.value = 2;
    s.connect(bp).connect(out);
    s.start();
    return 1.2;
  },
};

export const NOISE_NAMES = Object.keys(SOUNDS);
let lastAt = 0;

export const playRandomNoise = () => {
  const now = Date.now();
  if (now - lastAt < 1000) return null;
  lastAt = now;
  const { ctx, out } = getAudio();
  const name = NOISE_NAMES[Math.floor(Math.random() * NOISE_NAMES.length)];
  const g = ctx.createGain();
  const comp = ctx.createDynamicsCompressor();
  g.connect(comp).connect(out);
  const dur = SOUNDS[name](ctx, g);
  env(ctx, g, 0.7, dur);
  setTimeout(() => g.disconnect(), dur * 1000 + 300);
  window.__lastNoise = name;
  return name;
};
